import { ModalEnum } from "@/types/enums";
import AuthModal from "@/ui/new-components/modals/AuthModal.vue";
import CampaignModal from "@/ui/new-components/modals/CampaignModal.vue";
import DirectPurchaseModal from "@/ui/new-components/modals/DirectPurchaseModal.vue";
import LoadingModal from "@/ui/new-components/modals/LoadingModal.vue";
import PayAfterAuthModal from "@/ui/new-components/modals/PayAfterAuthModal.vue";
import PaymentFailedModal from "@/ui/new-components/modals/PaymentFailedModal.vue";
import PaymentSuccessModal from "@/ui/new-components/modals/PaymentSuccessModal.vue";
import PrePaymentModal from "@/ui/new-components/modals/PrePaymentModal.vue";
import { ref, type Component } from "vue";

const activeModal = ref<ModalEnum | null>(null);

export function useModalManager() {
  const registeredModals: Component[] = [
    AuthModal,
    PrePaymentModal,
    PaymentSuccessModal,
    PaymentFailedModal,
    PayAfterAuthModal,
    LoadingModal,
    DirectPurchaseModal,
    CampaignModal,
    // Add more modals here as needed
  ];

  const getModalFromString = (value: string): ModalEnum | null => {
    return (Object.values(ModalEnum) as string[]).includes(value) ? (value as ModalEnum) : null;
  };

  const setActiveModal = (modal: ModalEnum, queueModal: ModalEnum = null) => {
    activeModal.value = modal;
    if (queueModal) {
      localStorage.setItem("4c_queued_modal", queueModal);
    }
  };

  const openQueuedModal = () => {
    const queued = localStorage.getItem("4c_queued_modal");
    if (queued) {
      const modal = getModalFromString(queued);
      if (modal) {
        localStorage.removeItem("4c_queued_modal");
        setActiveModal(modal);
      }
    }
  };

  const getRedirectUrl = () => {
    return localStorage.getItem("4c_redirect_url");
  };

  const getQueuedModal = (): ModalEnum | null => {
    return getModalFromString(localStorage.getItem("4c_queued_modal"));
  };

  const executePendingActions = () => {
    openQueuedModal();
  }

  const setRedirectUrl = (path: string) => {
    localStorage.setItem("4c_redirect_url", path);
  };

  const removeRedirectUrl = () => {
    localStorage.removeItem("4c_redirect_url");
  };

  return {
    activeModal,
    registeredModals,
    setActiveModal,
    executePendingActions,
    getRedirectUrl,
    setRedirectUrl,
    getQueuedModal,
    removeRedirectUrl,
    getModalFromString,
  };
}
